export const ToastError = {
  style: {
    borderRadius: "0.5em",
    border: "2px solid transparent",
    background:
      "linear-gradient(var(--color-grey-2), var(--color-grey-2))padding-box,linear-gradient(to right, rgba(211, 0, 0, 0.83), rgba(0, 0, 0, 0.25))border-box",
    color: "var(--color-white-0)",
  },
  iconTheme: {
    primary: "var(--color-red-0)",
    secondary: "var(--color-white-0)",
  },
};
export const ToastSucess = {
  style: {
    borderRadius: "0.5em",
    border: "0.125rem solid transparent",
    background:
      "linear-gradient(var(--color-grey-2), var(--color-grey-2))padding-box,linear-gradient(to right, rgba(211, 0, 0, 0.83), rgba(0, 0, 0, 0.25))border-box",
    color: "var(--color-white-0)",
  },
  iconTheme: {
    primary: "var(--color-white-0)",
    secondary: "var(--color-red-0)",
  },
};
